import { NOTIFICATION_TYPE, Stages } from '../types';

export const STAGES_AFTER_QC = new Set<Stages>(['review', 'outcome']);

export const SUBMISSSION_DETAILS_V2_PATH = 'v2/submissions';

export const SUBMISSION_UPDATE_NO_RESPONSE_MESSAGE =
  "Something interrupted that action and it wasn't completed. Please try again in a moment. If the problem continues, contact your administrator.";

export const SUBMISSION_STAGE_MAPPER = new Map<Stages, string>([
  ['draft', 'Draft'],
  ['qc_check', 'Pre-review'],
  ['review', 'Review'],
  ['outcome', 'Outcome'],
  ['complete', 'Complete'],
]);

export const SUBMISSION_NOTIFICATION_TYPE_MAPPER = new Map<
  NOTIFICATION_TYPE,
  string
>([
  ['todo', 'To do'],
  ['on_hold', 'On hold'],
  ['all', 'all'],
]);
